export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["旧密码："])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新密码："])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认密码："])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"新密码\"和\"确认密码\"不匹配。"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更改密码"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["长度为4至63个字符。允许使用拉丁字母、数字和符号"])}
}